import type { ReactNode } from 'react';

export type BannerTone = 'ok' | 'attention' | 'error' | 'info';

/** A glyph as well as a colour, so the tone survives a greyscale screenshot. */
const GLYPH: Record<BannerTone, string> = { ok: '✓', attention: '!', error: '!', info: 'i' };

export function Banner({ tone, children }: { tone: BannerTone; children: ReactNode }) {
  return (
    <div className={`banner banner-${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <span aria-hidden="true" style={{ fontWeight: 700, opacity: .65, lineHeight: 1.6 }}>
        {GLYPH[tone]}
      </span>
      <span>{children}</span>
    </div>
  );
}
